<template>
  <div :class="$style.host" v-if="hasError">
    <span :class="$style.text">{{ error }}</span>
  </div>
</template>

<script>
export default {
  name: 'DistributorError',
  computed: {
    error() {
      return this.$store.state.distributorError;
    },
    hasError() {
      return !!this.error;
    },
  },
};
</script>

<style lang="scss" module>
.host {
  border: 1px solid $red;
  background-color: $red-light;
  padding: 10px 25px;
  text-align: center;
  margin-top: 15px;

  .text {
    @include font-open-sans-red;
  }
}
</style>
